import { render, staticRenderFns } from "./SubjectsEngaged.vue?vue&type=template&id=6a06d600&scoped=true"
import script from "./SubjectsEngaged.vue?vue&type=script&lang=js"
export * from "./SubjectsEngaged.vue?vue&type=script&lang=js"
import style0 from "./SubjectsEngaged.vue?vue&type=style&index=0&id=6a06d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06d600",
  null
  
)

export default component.exports